module.exports = __webpack_public_path__ + "img/syllabus.9849b10b.png";